import React from 'react'
import AppBar from '../../components/AppBar'
import CustomerSummaryPanelContainer from './CustomerSummaryPanelContainer'
import { info } from '../../storage'

export default class CustomerSummaryScene extends React.Component {
  handleBackScene = () => {
    if (this.props.history) this.props.history.goBack()
  }

  render() {
    const { stationName, serviceDisplayName } = info()
    return (
      <div>
        <AppBar
          header="Summary Report"
          subHeader={`Customer Summary (${stationName} - ${serviceDisplayName})`}
          hasBtnGroup
        />
        <div className="pt-20 px-4 md:px-8">
          <div className="pt-4 pb-20 w-full">
            <CustomerSummaryPanelContainer onBack={this.handleBackScene} />
          </div>
        </div>
      </div>
    )
  }
}
